module.exports = __webpack_public_path__ + "img/16.835c7919.jpg";